module.exports = __webpack_public_path__ + "img/ajax-loader.3a91c8a7.gif";